import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import InventoryService from '../../../services/InventoryService';
import { downloadFile, translate } from '../../../utils/util';
import { Breadcrumbs, Button, Select } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import SelectNew from '../../../components/UI/SelectNew';

const Report = (props) => {
    const secondCount = props.history?.location?.state?.secondCount;
    const [, setInstanceM] = useState();
    const [inventoryDrop, setInventoryDrop] = useState([]);
    const [filter, setFilter] = useState(
        {
            inventoryCode: props.inventory.code || "",
            secondCount: secondCount || false
        });

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        props.getInventoryCodes(props.user.filter, (response) => { setInventoryDrop(response) });
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const downloadReport = () => {
        if (validateInputsRequired()) {
            props.getReport(filter, (data) => {
                downloadFile(data, `ReportInventory${Date.now()}.csv`, "data:text/csv", false);
            });
        }
    }

    return (
        <div>
            <Breadcrumbs id="transmissionTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: 'Relatório' }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate("general:filter", "inventory")}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <div id="formsReport" className="row">

                                    <div className='input-field no-padding col s12'>
                                        <SelectNew
                                            required
                                            id="inventoryCode"
                                            name="inventoryCode"
                                            label={translate("inventoryCode", "inventory")}
                                            placeHolder={translate("chooseAnOption", "inventory")}
                                            data={inventoryDrop ? inventoryDrop.map((i) => { return { id: i.code, text: i.code }; }) : []}
                                            change={onChange}
                                            value={filter.inventoryCode || ""}
                                            disabled={secondCount}
                                        />
                                    </div>

                                </div>
                            </div>
                        </li>
                    </ul>
                    {
                        navigator.userAgent !== 'logisticspwa' &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadReport} full="true" text="Gerar Relatorio" />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        inventoryList: state.inventoryReducer.inventoryList,
        inventory: state.inventoryReducer.inventory
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReport: (filter, callback) => {
            dispatch(InventoryService.getReport(filter, callback));
        },
        getInventoryCodes: (filter, callback) => {
            dispatch(InventoryService.getInventoryCodes(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Report)));